<rt-dropdown *ngIf="admin" (click)="$event.preventDefault()">
  <div class="container">
    <div class="row">
      <div class="col">
        <rt-avatar type="image" size="medium" [imageSrc]="admin.photoThumbUrl"></rt-avatar>
      </div>
      <div class="col" margin-left-medium>
        <span class="name">{{ admin.firstName + ' ' + admin.lastName }}</span>
        <span>{{ admin.roleName }}</span>
      </div>
    </div>
    <div class="row" layout-align-items-center>
      {{ admin.email
      }}<rt-icon-button
        [rtTooltip]="'app.common.copy_to_clipboard' | translate"
        iconName="content-copy"
        size="small"
        variant="plain"
        (click)="copyEmail()"
        margin-left-small-x
      ></rt-icon-button>
    </div>
    <div class="row">{{ timezone }}</div>
  </div>
</rt-dropdown>
